import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HistoryIcon from "@mui/icons-material/History";
import { Card, CardContent, Grid, Tooltip } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { toJalaliDate } from "../../../middleware/middleware";

const Stat = ({
  type = "primary",
  value,
  unit,
  label,
  date,
  dateLabel,
  isTime = false,
  infoList = [],
  hasShowMore = false,
  showMore = {},
}) => {
  const card = (
    <Card className={clsx("stat-container", type)}>
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={12} className="label-container">
            {label}
          </Grid>

          <Grid item xs={12} md={12} className="header-container">
            <span className="value">{value}</span>
            <sub className="unit">{unit}</sub>

            {date ? (
              <Tooltip title={dateLabel} placement="top">
                <div className="date-container">
                  <div className="date">
                    {isTime ? date : toJalaliDate(date)}
                  </div>
                  <div className="label">
                    {isTime ? <AccessTimeIcon /> : <HistoryIcon />}
                  </div>
                </div>
              </Tooltip>
            ) : null}
          </Grid>

          {React.Children.toArray(
            infoList.map((info) => (
              <Grid item xs={12} md={12} className="info-container">
                <div className="info-title">{info.title}</div>
                <div className="info-value">
                  {info.value} <sub className="info-unit">{info.unit}</sub>
                </div>
              </Grid>
            ))
          )}
        </Grid>
      </CardContent>
    </Card>
  );

  if (hasShowMore) {
    return <Link to={showMore.link}>{card}</Link>;
  }

  return card;
};

export default Stat;
